[
  {
    "code": "TL-AL",
    "name": "Aileu"
  },
  {
    "code": "TL-AN",
    "name": "Ainaro"
  },
  {
    "code": "TL-BA",
    "name": "Baucau"
  },
  {
    "code": "TL-BO",
    "name": "Bobonaro"
  },
  {
    "code": "TL-CO",
    "name": "Cova Lima"
  },
  {
    "code": "TL-DI",
    "name": "Dili"
  },
  {
    "code": "TL-ER",
    "name": "Ermera"
  },
  {
    "code": "TL-LA",
    "name": "Lautem"
  },
  {
    "code": "TL-LI",
    "name": "Liquiça"
  },
  {
    "code": "TL-MT",
    "name": "Manatuto"
  },
  {
    "code": "TL-MF",
    "name": "Manufahi"
  },
  {
    "code": "TL-OE",
    "name": "Oecussi"
  },
  {
    "code": "TL-VI",
    "name": "Viqueque"
  }
]